
export function getUrlParts() {
    const activeUrl = new URL(location.href);
    const from = activeUrl.searchParams.get('from')

    return { path: activeUrl.pathname, from };
}